import { DayAvailability } from '../../../types'

interface Parameters {
  dateEndKey: string
  dateStartKey: string
  fresh?: DayAvailability
  stale?: DayAvailability
}

const mergeDayAvailability = ({ dateEndKey, dateStartKey, fresh: tmpFresh, stale: tmpStale }: Parameters): DayAvailability => {
  const isFocusedRange = (key: string) => key >= dateStartKey && key <= dateEndKey
  const fresh = tmpFresh ?? ({} as DayAvailability)
  const stale = tmpStale ?? ({} as DayAvailability)

  const reduced = Object.keys(stale).reduce<DayAvailability>((acc, key) => {
    if (isFocusedRange(key) && !fresh[key]) {
      return acc
    }

    return {
      ...acc,
      [key]: fresh[key] ?? stale[key],
    }
  }, {} as DayAvailability)

  return { ...reduced, ...fresh }
}

export { mergeDayAvailability }
